var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorBox = function SvgErrorBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#error_box_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F65050",
    d: "M20.8 0H0v24.108L6 19H0h20.8c1.12 0 1.68 0 2.109-.218a2 2 0 0 0 .874-.874C24 17.48 24 16.92 24 15.8V3.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C22.48 0 21.92 0 20.8 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.333 9a4.667 4.667 0 1 0 9.334 0 4.667 4.667 0 0 0-9.334 0ZM12 3a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm0 2.667c.368 0 .667.298.667.666v3.334a.667.667 0 0 1-1.334 0V6.333c0-.368.299-.666.667-.666Zm0 6.666A.667.667 0 1 0 12 11a.667.667 0 0 0 0 1.333Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "error_box_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgErrorBox;